import React from 'react'
import ScrollToTop from '../utils/ScrollToTop.jsx'
import ServicesItemContainer from '../containers/ServicesItemContainer.jsx'
import ServicesPoolContainer from '../containers/ServicesPoolContainer.jsx'
import GoogleMapContaier from '../containers/GoogleMapContainer.jsx'
import FooterBtnContainer from '../containers/FooterBtnContainer.jsx'

const Services = () => (
    <div>
        <ScrollToTop />
        <ServicesItemContainer />
        <ServicesPoolContainer />
        <GoogleMapContaier />
        <FooterBtnContainer />
    </div>
)

export default Services



// WEBPACK FOOTER //
// ./src/scripts/routes/Services.jsx